import { memo } from 'react';

import { IconOpenPreview } from '@components/icons/open-preview';
import { Menu } from '@components/menu';
import { useScopedTranslate } from '@locale/translate';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { usePreviewSmsModal } from './preview-sms-modal';
import { buildSmsPreviewProps, previewSmsLocale } from './sms-preview';

const ACTION_TYPE = ACTION_TYPES.send_sms;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const { t } = useScopedTranslate(locale);
  const showPreviewModal = usePreviewSmsModal();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={getActionLabel(ACTION_TYPE)}>
        <NodeActions
          node={node}
          customMenuItems={
            <Menu.Item
              label={t('previewSms')}
              icon={<IconOpenPreview />}
              onSelect={() =>
                showPreviewModal(buildSmsPreviewProps(node.data?.values, node.id, t('noRecipient')))
              }
            />
          }
        />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const locale = {
  en: {
    ...previewSmsLocale.en,
    noRecipient: 'SMS has no recipients',
  },
};
